import {
    createApp
} from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from '@/router'
import "vuetify/styles";
import '@mdi/font/css/materialdesignicons.css' // 确保引入了CSS
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { pl, zhHans } from 'vuetify/locale' 
  import vue3SeamlessScroll from "vue3-seamless-scroll";
// import VConsole from "vconsole";
// const vconsole = new VConsole()
const pinia = createPinia()
const vuetify = createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'mdi',
    },
    locale: {
        locale: 'zhHans',
        fallback: 'sv',
        messages: { zhHans },
    },
});
(function () {
    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
        handleFontSize();
    } else {
        if (document.addEventListener) {
            document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
        } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", handleFontSize);
            document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
        }
    }

    function handleFontSize() {
        // 设置网页字体为默认大小
        WeixinJSBridge.invoke('setFontSizeCallback', {
            'fontSize': 0
        });
        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function () {
            WeixinJSBridge.invoke('setFontSizeCallback', {
                'fontSize': 0
            });
        });
    }
})();
createApp(App).use(vue3SeamlessScroll).use(router).use(vuetify).use(pinia).mount('#app')